/**
 * Context resolver for investigation pipeline help panel scroll highlight.
 */

const STAGE_TO_HELP = {
  investigation: 'stages-early',
  pending_evidence: 'stages-early',
  suspicion_formed: 'stages-smr',
  smr_draft: 'stages-smr',
  under_review: 'stages-smr',
  filed: 'stages-filed',
  closed: 'stages-early',
}

export function primaryHelpSectionForPipeline({ selectedStage, settingsOpen, stageLabelsOpen }) {
  if (settingsOpen) return 'routing'
  if (stageLabelsOpen) return 'routing'
  if (selectedStage && STAGE_TO_HELP[selectedStage]) return STAGE_TO_HELP[selectedStage]
  if (selectedStage) return 'drawer'
  return 'overview'
}
